import { liquidGlassRowShadowSx, liquidGlassSurfaceFillSx, miniButtonDockScrollBottomPad, ThemedSkeleton } from '@focuslee/shared-mini-app';
import { Box, Stack } from '@mui/material';
import { FC } from 'react';
import { Page } from '../../Page';

export const AchievementListSkeleton: FC = () => {
    return (
        <Page back insetEnabled={false}>
            <Stack direction="row" alignItems="center" justifyContent="center" gap={1} mt={1} mb={3}>
                <ThemedSkeleton variant="rectangular" width={30} height={30} sx={{ borderRadius: 2 }} />
                <ThemedSkeleton variant="text" width={150} height={28} />
            </Stack>
            <Box
                sx={{
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    px: '16px',
                    pb: miniButtonDockScrollBottomPad,
                }}
            >
                <Box sx={{ width: '100%', borderRadius: '16px', overflow: 'hidden', ...liquidGlassRowShadowSx }}>
                    <Box sx={{ borderRadius: 'inherit', ...liquidGlassSurfaceFillSx }}>
                        {Array.from({ length: 5 }).map((_, i) => (
                            <Stack
                                key={i}
                                direction="row"
                                alignItems="center"
                                gap={1.5}
                                sx={{
                                    p: 1.5,
                                    borderTop:
                                        i > 0 ? '1px solid color-mix(in srgb, var(--tg-theme-text-color) 16%, transparent)' : 'none',
                                }}
                            >
                                <ThemedSkeleton
                                    variant="rectangular"
                                    width={60}
                                    height={80}
                                    sx={{ borderRadius: 1.5, flexShrink: 0 }}
                                />
                                <Stack spacing={0.75} sx={{ flex: 1 }}>
                                    <ThemedSkeleton variant="text" width="55%" height={18} />
                                    <ThemedSkeleton variant="text" width="85%" height={14} />
                                    <ThemedSkeleton variant="rectangular" width="100%" height={10} sx={{ borderRadius: 999 }} />
                                </Stack>
                            </Stack>
                        ))}
                    </Box>
                </Box>
            </Box>
        </Page>
    );
};
